import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FormContainer from "../components/FormContainer";
import API_BASE_URL from "../config/api";

const PRIORITY_MACHINES = [
  { key: "SUPERSEEDER", label: "Super Seeder" },
  { key: "ROTAVATOR", label: "Rotavator" },
  { key: "MULCHER", label: "Mulcher" },
  { key: "RMBPLOUGH", label: "RMB Plough" },
  { key: "ZEROTILLDRILL", label: "Zero Till Drill" },
  { key: "ROTARYSLASHER", label: "Rotary Slasher" },
  { key: "PADDYSTRAWCHOPPER", label: "Paddy Straw Chopper" },
  { key: "BALER", label: "Baler" },
  { key: "RAKER", label: "Raker" },
  { key: "REAPER", label: "Reaper" },
  { key: "TRACTOR", label: "Tractor" },
  { key: "HAPPYSEEDER", label: "Happy Seeder" },
  { key: "SURFACESEEDER", label: "Surface Seeder" },
];

const REMAINING_MACHINES = [
  { key: "SMARTSEEDER", label: "Smart Seeder" },
  { key: "SUPERSMS", label: "Super SMS" },
  { key: "SHRUBMASTER", label: "Shrub Master" },
  { key: "CUTTERCUMSPREADER", label: "Cutter Cum Spreader" },
  { key: "TRACTORTROLLEY", label: "Tractor Trolley" },
  { key: "LASERLEVELLER", label: "Laser Leveller" },
  { key: "DIRECTSEEDERRICE", label: "Direct Seeder Rice" },
  { key: "MAIZEPLANTERMECHANICAL", label: "Maize Planter Mechanical" },
  { key: "MAIZEPLANTERVACCUM", label: "Maize Planter Vacuum" },
  { key: "SPRAYPUMP", label: "Spray Pump" },
  { key: "PRESSUREDISKS", label: "Pressure Disks" },
  { key: "DISKLOCK", label: "Disk Lock" },
  { key: "BIOFERTILIZERSPREADER", label: "Bio Fertilizer Spreader" },
  { key: "CULTIVATOR", label: "Cultivator" },
  { key: "SUBSOILER", label: "Subsoiler" },
  { key: "POWERCLEANER", label: "Power Cleaner" },
  { key: "DISCRAZOR", label: "Disc Razor" },
  { key: "HARROWTRIPPLE", label: "Harrow Tripple" },
  { key: "COTTONSEEDDRILL", label: "Cotton Seed Drill" },
  { key: "WATERTANK", label: "Water Tank" },
  { key: "SUHAGA", label: "Suhaga" },
  { key: "WHEATSEEDFAN", label: "Wheat Seed Fan" },
  { key: "SEEDGRINDINGMACHINE", label: "Seed Grinding Machine" },
  { key: "JINDRA", label: "Jindra" },
  { key: "COMBINE", label: "Combine" },
  { key: "SEELARCOTTON", label: "Seelar Cotton" },
  { key: "GENERATOR", label: "Generator" },
  { key: "WHEATSEEDDRILL", label: "Wheat Seed Drill" },
  { key: "PLOUGH", label: "Plough" },
  { key: "GROUNDLEVELLER", label: "Ground Leveller" },
  { key: "STRAWREAPER", label: "Straw Reaper" },
  { key: "POTATOPLANTER", label: "Potato Planter" },
  { key: "TAWIAN", label: "Tawian" },
  { key: "SIMPLELEVELLER", label: "Simple Leveller" },
  { key: "LOADER", label: "Loader" },
  { key: "POTATODRILL", label: "Potato Drill" },
  { key: "MULTIDRILLMACHINE", label: "Multi Drill Machine" },
  { key: "PUDDLER", label: "Puddler" },
  { key: "CHOPPER", label: "Chopper" },
  { key: "CORNDRILL", label: "Corn Drill" },
  { key: "PEASMACHINE", label: "Peas Machine" },
  { key: "SEEDDRILL", label: "Seed Drill" },
  { key: "CHIZLER", label: "Chizler" },
  { key: "PADDYPLANTER", label: "Paddy Planter" },
  { key: "DIESELTANK", label: "Diesel Tank" },
  { key: "BHAUNI", label: "Bhauni" },
  { key: "TOTA", label: "Tota" },
  { key: "TILLER", label: "Tiller" },
  { key: "KARAH", label: "Karah" },
  { key: "TARFALI", label: "Tarfali" },
  { key: "RAZOR", label: "Razor" },
  { key: "THRESHER", label: "Thresher" },
  { key: "KARCHAMACHINE", label: "Karcha Machine" },
  { key: "RATOR", label: "Rator" },
  { key: "SUGARCANERAGER", label: "Sugar Cane Rager" },
  { key: "DISCHARROW", label: "Disc Harrow" },
  { key: "CHAINKUPPI", label: "Chain Kuppi" },
  { key: "SUGARCANESEEDER", label: "Sugar Cane Seeder" },
  { key: "GRINDER", label: "Grinder" },
  { key: "CHANGER", label: "Changer" },
  { key: "TRIPPLEPLOUGH", label: "Tripple Plough" },
  { key: "CORNHARVESTER", label: "Corn Harvester" },
  { key: "CUTTER", label: "Cutter" },
  { key: "MOTORMACHINE", label: "Motor Machine" },
  { key: "DISCPLOUGH", label: "Disc Plough" },
  { key: "GAINIPLOUGH", label: "Gaini Plough" },
  { key: "DUGPLOUGH", label: "Dug Plough" },
  { key: "OFFSETHARROW", label: "Offset Harrow" },
  { key: "JAAL", label: "Jaal" },
  { key: "TARAKADI", label: "Tarakadi" },
  { key: "CARROTMACHINE", label: "Carrot Machine" },
  { key: "DISCBEDMAKER", label: "Disc Bed Maker" },
  { key: "LOADERBUCKET", label: "Loader Bucket" },
  { key: "SEEDGRADER", label: "Seed Grader" },
  { key: "ACHATHALL", label: "Achathall" },
  { key: "TAWAWATTA", label: "Tawa Watta" },
  { key: "JACK", label: "Jack" },
];

const ALL_MACHINES = [...PRIORITY_MACHINES, ...REMAINING_MACHINES];

const MachineTypesPage = ({ user }) => {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({});
  const [authorizedCounts, setAuthorizedCounts] = useState({});
  const [acres, setAcres] = useState("");
  const [noOfMembers, setNoOfMembers] = useState("");
  const [period, setPeriod] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const societyId = user.society ? user.society._id : null;

  useEffect(() => {
    if (!societyId) {
      setLoading(false);
      return;
    }

    const fetchCounts = async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}/api/machines/counts?societyId=${societyId}`,
        );
        console.log("societyId", societyId);
        const data = await res.json();
        if (data.success) {
          console.log("data", data);
          setPeriod(data.period);
          console.log("data.counts", data.counts);
          setCounts(data.counts || {});
          setAuthorizedCounts(data.authorizedCounts || {});
          console.log("data.society", data.society);
          setAcres(data.ACRES !== undefined ? data.ACRES : "");
          setNoOfMembers(
            data.NO_OF_MEMBERS !== undefined ? data.NO_OF_MEMBERS : "",
          );
        }
      } catch (err) {
        console.error("Error loading machine counts:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, [societyId]);

  const handleInputChange = (key, value) => {
    const num = Math.max(0, parseInt(value, 10) || 0);
    setCounts((prev) => ({
      ...prev,
      [key]: num,
    }));
  };

  const handleSave = async () => {
    if (!societyId) {
      setStatus({
        type: "error",
        message: "No Society linked to user account.",
      });
      return;
    }

    setSaving(true);
    setStatus({ type: "", message: "" });

    try {
      const res = await fetch(`${API_BASE_URL}/api/machines/counts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          societyId,
          counts,
          acres: acres === "" ? 0 : Number(acres),
          noOfMembers: noOfMembers === "" ? 0 : Number(noOfMembers),
        }),
      });

      const data = await res.json();
      if (res.ok && data.success) {
        setStatus({
          type: "success",
          message: "Machine counts and society details saved successfully!",
        });
      } else {
        setStatus({
          type: "error",
          message: data.message || "Failed to save machine counts.",
        });
      }
    } catch (err) {
      console.error("Error saving counts:", err);
      setStatus({
        type: "error",
        message: "Network error saving machine counts.",
      });
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    navigate("/home");
  };

  if (!societyId) {
    return (
      <FormContainer
        title="View / Edit Machine Types"
        onClose={handleClose}
        onCancel={handleClose}
        saveText="Save"
      >
        <p style={{ color: "#dc2626" }}>
          No society record found for your login account.
        </p>
      </FormContainer>
    );
  }

  if (loading) {
    return (
      <FormContainer
        title="View / Edit Machine Types"
        onClose={handleClose}
        onCancel={handleClose}
        saveText="Save"
      >
        <p>Loading machine count form...</p>
      </FormContainer>
    );
  }

  const societyName = user.society
    ? user.society.SOCIETY || user.society.SocietyName
    : "N/A";

  return (
    <>
      {status.message && (
        <div className="toast-notification">
          <span>{status.type === "error" ? "⚠️" : "✅"}</span> {status.message}
        </div>
      )}
      <FormContainer
        title={`View / Edit Machine Types — ${societyName}`}
        onClose={handleClose}
        onSave={handleSave}
        onCancel={handleClose}
        saveText="Save"
        saving={saving}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            flexWrap: "wrap",
            gap: "12px",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "#64748b",
              margin: 0,
              fontWeight: "500",
            }}
          >
            Society: <strong>{societyName}</strong>
          </p>
          {period && (
            <div
              style={{
                background: "#e0e7ff",
                color: "#4318ff",
                padding: "6px 14px",
                borderRadius: "8px",
                fontWeight: "600",
                fontSize: "13px",
              }}
            >
              📅 Active Period: {period.StartDate} to {period.EndDate} (
              {period.seasonName || period.PERIOD})
            </div>
          )}
        </div>

        {/* Society Details: Acres and Number of Members */}
        <div
          style={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "20px",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "16px",
          }}
        >
          <div>
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: "600",
                color: "#334155",
                marginBottom: "6px",
              }}
            >
              Acres covered
            </label>
            <input
              type="number"
              min="0"
              placeholder="Enter Total Acres"
              value={acres}
              onChange={(e) => setAcres(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #cbd5e1",
                fontSize: "14px",
                fontWeight: "600",
                color: "#1e293b",
                outline: "none",
                boxSizing: "border-box",
              }}
              disabled={saving}
            />
          </div>
          <div>
            <label
              style={{
                display: "block",
                fontSize: "13px",
                fontWeight: "600",
                color: "#334155",
                marginBottom: "6px",
              }}
            >
              Number of Members
            </label>
            <input
              type="number"
              min="0"
              placeholder="Enter Number of Members"
              value={noOfMembers}
              onChange={(e) => setNoOfMembers(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #cbd5e1",
                fontSize: "14px",
                fontWeight: "600",
                color: "#1e293b",
                outline: "none",
                boxSizing: "border-box",
              }}
              disabled={saving}
            />
          </div>
        </div>

        {/* Structured Machine Counts Table */}
        <div
          style={{
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            overflow: "hidden",
            background: "#ffffff",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "13px",
              textAlign: "left",
            }}
          >
            <thead>
              <tr
                style={{
                  background: "#f1f5f9",
                  borderBottom: "1px solid #cbd5e1",
                  color: "#334155",
                }}
              >
                <th
                  style={{
                    padding: "12px 16px",
                    fontWeight: "700",
                    width: "50px",
                  }}
                >
                  #
                </th>
                <th style={{ padding: "12px 16px", fontWeight: "700" }}>
                  Machine Name
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    fontWeight: "700",
                    width: "220px",
                    textAlign: "center",
                  }}
                >
                  Machine Count
                </th>
                <th
                  style={{
                    padding: "12px 16px",
                    fontWeight: "700",
                    width: "220px",
                    textAlign: "center",
                  }}
                >
                  Authorized Machine Count
                </th>
              </tr>
            </thead>
            <tbody>
              {ALL_MACHINES.map((m, idx) => {
                const currentVal =
                  counts[m.key] !== undefined ? counts[m.key] : 0;
                const authVal =
                  authorizedCounts[m.key] !== undefined
                    ? authorizedCounts[m.key]
                    : 0;

                return (
                  <tr
                    key={m.key}
                    style={{
                      borderBottom: "1px solid #f1f5f9",
                      background: idx % 2 === 0 ? "#ffffff" : "#f8fafc",
                    }}
                  >
                    <td style={{ padding: "10px 16px", color: "#64748b" }}>
                      {idx + 1}
                    </td>
                    <td
                      style={{
                        padding: "10px 16px",
                        fontWeight: "600",
                        color: "#1e293b",
                      }}
                    >
                      {m.label}
                    </td>
                    <td style={{ padding: "10px 16px", textAlign: "center" }}>
                      <input
                        type="number"
                        min="0"
                        value={currentVal}
                        onChange={(e) =>
                          handleInputChange(m.key, e.target.value)
                        }
                        style={{
                          width: "110px",
                          padding: "6px 10px",
                          borderRadius: "6px",
                          border: "1px solid #cbd5e1",
                          textAlign: "center",
                          fontSize: "13px",
                          fontWeight: "600",
                          outline: "none",
                        }}
                        disabled={saving}
                      />
                    </td>
                    <td
                      style={{
                        padding: "10px 16px",
                        textAlign: "center",
                        fontWeight: "600",
                        color: "#475569",
                      }}
                    >
                      <span
                        style={{
                          background: "#e2e8f0",
                          padding: "4px 14px",
                          borderRadius: "12px",
                          fontSize: "12px",
                        }}
                      >
                        {authVal}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </FormContainer>
    </>
  );
};

export default MachineTypesPage;
